import { ReactElement } from 'react';
import cn from 'classnames';

import cms from '../../data/cms.json';

import { Icon } from '../Icon/Icon';
import styles from './Download.module.scss';
import { DocumentProps } from '../_pages/Step10/Step10';
import { getBaseUrl } from '../../utils/getBaseUrl';
import { getDataTest } from '../../utils/dataTests';

interface DownloadProps {
    files: ReadonlyArray<DocumentProps>;
    className?: string;
}

export const Download = ({ files, className, ...props }: DownloadProps): ReactElement | null => {
    return (
        <div className={cn(styles.wrapper, className)} {...props}>
            {files.map((f, i) => (
                <div key={i} className={styles.file} data-test={getDataTest(props, `File[${i}]`)}>
                    <Icon name="document" className={styles.documentIcon} data-test="icon" />
                    <span className={styles.fileName} data-test="fileName">
                        {f.DisplayName}
                    </span>
                    <a
                        className={styles.download}
                        href={`${getBaseUrl()}api/online/misc/get-document-content/${f.ExternalId}`}
                        target="_blank"
                        rel="noreferrer"
                        data-test="fileDownloadLink"
                    >
                        <Icon name="download" className={styles.downloadIcon} data-test="fileDownloadIcon" />
                        {cms.common.downloadButton}
                    </a>
                </div>
            ))}
        </div>
    );
};
